module.exports = __webpack_public_path__ + "img/doom-eternal.c0b76df4.png";